module.exports = __webpack_public_path__ + "img/call-types-mobile.af2cc228.svg";